import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import cmuEsCL from './locales/es-CL.json';
import cmuEnUS from './locales/en-US.json';
import cmuPtBR from './locales/pt-BR.json';

export const caseMovementsUnholsterI18n = buildScopedI18n({
  esCL: cmuEsCL,
  enUS: cmuEnUS,
  ptBR: cmuPtBR,
});
